<template>
    <v-container class="text-right">
        <v-btn x-small :color="groupSetting.mainColor" icon dark class="ml-n3 pa-1" @click="deleteEstimation">
            <v-icon>mdi-delete-circle</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
import axios from "axios";
import store from "@/store";

export default {
    name: 'DeleteEstimationButton',
    props: {
        estimationId: {}
    },
    data() {
        return {
            groupSetting: null
        }
    },
    methods: {
        deleteEstimation() {

            if(!confirm('삭제 시 복구가 불가합니다.\n정말 삭제하시겠습니까?')){
                return false
            }

            if(!this.estimationId){
                alert('견적번호가 없습니다.\n개발자에게 문의하세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + store.getters.getAccessToken
                },
                url: store.getters.getApiUrl + '/api/v1/estimation/deleteEstimation/' + this.estimationId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data && response.data.status == '0000'){

                    alert(response.data.message)
                    location.reload()

                }else{

                    alert(response.data.message)
                    return false

                }

            })

        }
    },
    created: function() {
        if(this.$store.getters.getAccessToken != null){
            this.groupSetting = this.$store.getters.getGroupSetting
        }
    }
}
</script>